import React from 'react';

type VariantType = 'fill' | 'line';
type ColorType = 'primary' | 'gray';
type EmphasisType = 'heavy' | 'light';
type ShapeType = 'box' | 'round';
type SizeType = 'md' | 'lg';

type Props = {
  className?: string;
  variant?: VariantType;
  color?: ColorType;
  emphasis?: EmphasisType;
  shape?: ShapeType;
  size?: SizeType;
  children?: React.ReactNode;
};

const COLOR_CLASS: Record<
  VariantType,
  Record<ColorType, Record<EmphasisType, string>>
> = {
  fill: {
    primary: {
      heavy: 'bg-apps-corePrimary01',
      light: 'bg-apps-corePrimary04 text-apps-corePrimary01',
    },
    gray: {
      heavy: 'bg-apps-coreGray02',
      light: 'bg-apps-coreGray06 text-apps-coreGray01',
    },
  },
  line: {
    primary: {
      heavy:
        'bg-none shadow-[inset_0px_0px_0px_1px_var(--color-apps-corePrimary01)] text-apps-corePrimary01',
      // 해당 스타일 없음
      light: '',
    },
    gray: {
      heavy: 'bg-none border border-apps-coreGray05 text-apps-coreGray01',
      // 해당 스타일 없음
      light: '',
    },
  },
};

const SHAPE_CLASS: Record<ShapeType, string> = {
  box: 'rounded-lg',
  round: 'rounded-[50px]',
};

const SIZE_CLASS: Record<SizeType, string> = {
  md: 'px-2 py-0.5',
  lg: 'px-3 py-1.5',
};

export default function Badge({
  className,
  variant = 'fill',
  color = 'primary',
  emphasis = 'heavy',
  shape = 'box',
  size = 'md',
  children,
}: Props) {
  return (
    <span
      className={`inline-flex h-fit items-center text-sm font-bold leading-[140%] tracking-[-0.28px] text-apps-coreGrayWhite ${COLOR_CLASS[variant][color][emphasis]} ${SHAPE_CLASS[shape]} ${SIZE_CLASS[size]} ${className ?? ''}`}
    >
      {children}
    </span>
  );
}
